import api from '../../services/api';
import { toast } from 'react-toastify';
import i18n from '../../utils/i18n.ts';

export const checkUser = async (userId: string) => {
  const response = await api.get(`/usersEntra/check/${userId}`);
  return response?.data;
};

export const fetchUsers = async () => {
  const response = await api.get(`/users`);

  if (!response) {
    toast.error(i18n.t('error.api.get-list', { item: i18n.t('module.users') }));
  }

  return response.data;
};

export const createUserRoles = async ({ data }: { data: unknown }) => {
  const response = await api.post(`/users`, data);

  if (!response) {
    toast.error(i18n.t('error.api.put-item', { item: i18n.t('module.user') }));
  }

  return response;
};

export const updateUserRoles = async ({
  userId,
  data,
}: {
  userId: string | number;
  data: unknown;
}) => {
  const response = await api.put(`/users/${userId}/roles`, data);

  if (!response) {
    toast.error(i18n.t('error.api.put-item', { item: i18n.t('module.user') }));
  }

  return true;
};
